import styles from "./dashboardLayout.module.scss";
import { ReactComponent as Menu } from "../../assets/menu.svg";
import { Spin } from "antd";

const Header = ({
  handleOpenSidebar,
  image,
  isLoading,
}: {
  handleOpenSidebar: () => void;
  image: string;
  isLoading: boolean;
}) => {
  return (
    <header className={styles.header}>
      <section className={styles.headerMenuGroup}>
        <button onClick={handleOpenSidebar} className={styles.menuBtn}>
          <Menu />
        </button>
      </section>

      {isLoading ? (
        <Spin />
      ) : (
        <section className={styles.headerGroup}>
          <img className={styles.avatar} src={image} alt="profile pic" />
        </section>
      )}
    </header>
  );
};

export default Header;
